import { FaFire, FaSnowflake, FaSun, FaWater, FaWindowRestore } from "react-icons/fa";
import { HeatWaveDashboard, ColdWaveDashboard, FireDashboard, FloodDashboardIcon, Avalanche } from "../../../Components/IconComponents";
import { MountainSnow } from "lucide-react";
import SvgThunderstorm from "../../../Components/IconComponents/Thunderstorm";
import SvgMountain from "../../../Components/IconComponents/Mountain";
const height = "1.2em";
const width = "1.2em";
export const maindashboardCardConfig = [
  {
    id: 0,
    title: "Floods",
    title1: "Human Loss",
    icon: <FaWater />, // ✅ Add the appropriate icon
    data: [
      {
        label: "Population Affected",
        // key: "families_gr_distributed",
        key: "population_affected",
        apiKey: "getReliefDetails",
        apiKey2: "trnd_families_gr_distributed",
      },
      {
        label: "Population Evacuated",
        // key: "dry_ration",
        key: "population_evacuated",
        apiKey: "getReliefDetails",
        apiKey2: "trnd_dry_ration",
      },
      {
        label: "Human Loss",
        // key: "polythene_sheets",
        key: "humans_loss",
        apiKey: "getReliefDetails",
        apiKey2: "trnd_polythene_sheets",
      },
      {
        label: "Motor Boats",
        // key: "polythene_sheets",
        key: "motor_boat",
        apiKey: "getReliefDetails",
        apiKey2: "trnd_polythene_sheets",
      },
      {
        label: "Animal shelter",
        // key: "polythene_sheets",
        key: "animal_shelter",
        apiKey: "getReliefDetails",
        apiKey2: "trnd_polythene_sheets",
      },
    ],
  },
  {
    id: 1,
    title: "Fire",
    title1: "Human Loss",
    icon: <MountainSnow width={width} height={height} />, // ✅ Add the appropriate icon
    data: [],
  },
  {
    id: 2,
    title: "Heat Wave",
    title1: "Human Loss",
    icon: <SvgThunderstorm width={width} height={height} />, // ✅ Add the appropriate icon
    data: [],
  },
  {
    id: 3,
    title: "Cold Wave",
    title1: "Human Loss",
    icon: <SvgMountain width={width} height={height} />, // ✅ Add the appropriate icon
    data: [],
  },
];
